import { getAccountVerificationStatus, postAccountVerificationDocuments } from '@/utils/api';
import i18n from '@/utils/i18n';
import Vue from 'vue';
import router from '@/router';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import { LoginTypes } from '@/utils/enums';

Vue.use(Vuex);

const state = {
  accountVerificationStatus: null,

  accountVerificationRequestStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateAccountVerificationStatusRequest(state, row) {
    state.accountVerificationRequestStatus = {
      ...state.accountVerificationRequestStatus,
      ...row,
    };
  },
  setAccountVerificationStatus(state, row) {
    state.accountVerificationStatus = row;
  },
};

const actions = {
  tryGetAccountVerificationStatus({ commit, rootGetters, rootState }) {
    commit('updateAccountVerificationStatusRequest', {
      loading: true,
      success: false,
      error: false,
    });
    getAccountVerificationStatus().then(r => {
      if (r.data.IsSuccess) {
        commit('updateAccountVerificationStatusRequest', { success: true });
        // const d = {
        //   "customer_account": "MB722832",
        //   "pending": [
        //     {
        //       "type": "sms"
        //     },
        //     {
        //       "type": "docs",
        //       "docs": {
        //         "id_photo": "id_photo",
        //         "poa": "poa",
        //         "cc": {
        //           "10000": "13123",
        //           "10002": "1312233",
        //         }
        //       }
        //     },
        //     {
        //       "type": "link"
        //     }
        //   ],
        //   "verified": null,
        //   "sms_verified": false,
        //   "docs_verified": null
        // };
        r.data.Data.verified = true;
        commit('setAccountVerificationStatus', r.data.Data);
        // commit("setAccountVerificationStatus", d)
      } else {
        commit('updateAccountVerificationStatusRequest', { error: true });
      }
      commit('updateAccountVerificationStatusRequest', { loading: false });
    });
  },
  tryPostDocuments({ commit, rootGetters, rootState }, formData) {
    commit('updateAccountVerificationStatusRequest', {
      loading: true,
      success: false,
      error: false,
    });
    postAccountVerificationDocuments(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('updateAccountVerificationStatusRequest', { success: true });
        router.push('/account-verification');
      } else {
        commit('updateAccountVerificationStatusRequest', { error: true });
      }
      commit('updateAccountVerificationStatusRequest', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
